import trim from "lodash-es/trim"
import type { ObjectSchema } from "yup"
import * as yup from "yup"

import type { TTFunction } from "$/i18n/i18n"

import type { TAuthContainerMode } from "./auth.ui.types"

function getAuthSchemaConfig(params: { t: TTFunction }): { [M in TAuthContainerMode]: ObjectSchema } {
    return {
        login: yup.object({
            email: yup
                .string()
                .transform((value: string): string => trim(value))
                .email(params.t("auth.emailInput.validation.wrongFormat"))
                .required(params.t("auth.emailInput.validation.required")),
            password: yup
                .string()
                .transform((value: string): string => trim(value))
                .required(params.t("auth.passInput.validation.required"))
                .min(8, params.t("auth.passInput.validation.minCount"))
                .max(100, params.t("auth.passInput.validation.maxCount"))
        }),
        register: yup.object({
            password: yup
                .string()
                .transform((value: string): string => trim(value))
                .required(params.t("auth.passInput.validation.required"))
                .min(8, params.t("auth.passInput.validation.minCount"))
                .max(100, params.t("auth.passInput.validation.maxCount")),
            confirmPassword: yup
                .string()
                .transform((value: string): string => trim(value))
                .required(params.t("auth.passInput.validation.repeatRequired"))
                .min(8, params.t("auth.passInput.validation.minCount"))
                .max(100, params.t("auth.passInput.validation.maxCount"))
                .oneOf([yup.ref("password")], params.t("auth.passInput.validation.notEqual"))
        }),
        reset: yup.object({
            password: yup
                .string()
                .transform((value: string): string => trim(value))
                .required(params.t("auth.passInput.validation.required"))
                .min(8, params.t("auth.passInput.validation.minCount"))
                .max(100, params.t("auth.passInput.validation.maxCount")),
            confirmPassword: yup
                .string()
                .required(params.t("auth.passInput.validation.repeatRequired"))
                .transform((value: string): string => trim(value))
                .min(8, params.t("auth.passInput.validation.minCount"))
                .max(100, params.t("auth.passInput.validation.maxCount"))
                .oneOf([yup.ref("password")], params.t("auth.passInput.validation.notEqual"))
        })
    }
}

export { getAuthSchemaConfig }
